import React from 'react';

export const GlassGradient = ({ id }) => (
  <defs>
    <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stopColor="white" stopOpacity="0.7" />
      <stop offset="100%" stopColor="white" stopOpacity="0" />
    </linearGradient>
  </defs>
);

export const GlassPanel = ({ x, y, w, h, gradId }) => (
  <g>
    <rect x={x} y={y} width={w} height={h} fill="#BDD2ED" />
    <rect x={x} y={y} width={w} height={h} fill={`url(#${gradId})`} />
    <rect x={x} y={y} width={w} height={h} fill="none" stroke="#333" strokeWidth="1" />
  </g>
);

export const Handle = ({ x, y }) => (
  <rect x={x - 2} y={y - 4} width="4" height="8" rx="1" fill="#555" />
);

// Line-only triangle for battente opening (no fill)
// SX = cerniera a sinistra, apice a sinistra (punta verso cerniera)
// DX = cerniera a destra, apice a destra (punta verso cerniera)
export const BattenteTriangleFill = ({ x, y, w, h, side, color = "#0055CC" }) => {
  let points;
  if (side === 'left') {
    // Cerniera a sinistra: apice a destra, base a sinistra
    points = `${x + w},${y + h / 2} ${x},${y} ${x},${y + h}`;
  } else {
    // Cerniera a destra: apice a sinistra, base a destra
    points = `${x},${y + h / 2} ${x + w},${y} ${x + w},${y + h}`;
  }
  return <polygon points={points} fill="none" stroke={color} strokeWidth="1" />;
};

// Anta-Ribalta: battente line triangle + dashed vasistas triangle on top
export const AntaRibaltaFill = ({ x, y, w, h, side, color = "#0055CC" }) => (
  <g>
    <BattenteTriangleFill x={x} y={y} w={w} h={h} side={side} color={color} />
    {/* Dashed vasistas triangle: apex at top-center, base at bottom */}
    <polygon
      points={`${x + w / 2},${y} ${x},${y + h} ${x + w},${y + h}`}
      fill="none" stroke={color} strokeWidth="1" strokeDasharray="3,2"
    />
  </g>
);

// Vasistas only: triangle apex at top-center (line only)
export const VasistasFill = ({ x, y, w, h, color = "#0055CC" }) => (
  <polygon
    points={`${x + w / 2},${y} ${x},${y + h} ${x + w},${y + h}`}
    fill="none" stroke={color} strokeWidth="1"
  />
);

// Fixed panel: cross (+) mark
export const FixedMark = ({ x, y, w, h, color = "#888" }) => (
  <g>
    <line x1={x + w / 2} y1={y + h * 0.25} x2={x + w / 2} y2={y + h * 0.75} stroke={color} strokeWidth="1.2" />
    <line x1={x + w * 0.25} y1={y + h / 2} x2={x + w * 0.75} y2={y + h / 2} stroke={color} strokeWidth="1.2" />
  </g>
);

// Sliding arrow
export const SlidingArrow = ({ x, y, direction = 'right', length = 30, color = "#0055CC" }) => {
  const endX = direction === 'right' ? x + length : x - length;
  const a = 5;
  return (
    <g>
      <line x1={x} y1={y} x2={endX} y2={y} stroke={color} strokeWidth="1.5" />
      <line x1={endX - (direction === 'right' ? a : -a)} y1={y - a} x2={endX} y2={y} stroke={color} strokeWidth="1.5" />
      <line x1={endX - (direction === 'right' ? a : -a)} y1={y + a} x2={endX} y2={y} stroke={color} strokeWidth="1.5" />
    </g>
  );
};

// Bilico horizontal indicator: axis line + up/down triangles (line only)
export const BilicoH = ({ x, y, w, h, color = "#0055CC" }) => (
  <g>
    <line x1={x} y1={y + h / 2} x2={x + w} y2={y + h / 2} stroke={color} strokeWidth="1" strokeDasharray="4,2" />
    <polygon points={`${x + w / 2},${y + 4} ${x + w * 0.35},${y + h * 0.45} ${x + w * 0.65},${y + h * 0.45}`} fill="none" stroke={color} strokeWidth="0.8" />
    <polygon points={`${x + w / 2},${y + h - 4} ${x + w * 0.35},${y + h * 0.55} ${x + w * 0.65},${y + h * 0.55}`} fill="none" stroke={color} strokeWidth="0.8" />
  </g>
);

// Bilico vertical indicator (line only)
export const BilicoV = ({ x, y, w, h, color = "#0055CC" }) => (
  <g>
    <line x1={x + w / 2} y1={y} x2={x + w / 2} y2={y + h} stroke={color} strokeWidth="1" strokeDasharray="4,2" />
    <polygon points={`${x + 4},${y + h / 2} ${x + w * 0.45},${y + h * 0.35} ${x + w * 0.45},${y + h * 0.65}`} fill="none" stroke={color} strokeWidth="0.8" />
    <polygon points={`${x + w - 4},${y + h / 2} ${x + w * 0.55},${y + h * 0.35} ${x + w * 0.55},${y + h * 0.65}`} fill="none" stroke={color} strokeWidth="0.8" />
  </g>
);

